import { Link } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { useMemo, Fragment } from 'react';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { NBSP } from '~/common/constants';
import { eventStopPropagation } from '~/util/function/eventStopPropagation';

export type ExternalLinkCellValue = Union.Nullable<string>;

interface ExternalLinkCellProps<R extends GridValidRowModel = any> {
  value: ExternalLinkCellValue | ExternalLinkCellValue[];
  row: R;
}

export const ExternalLinkCell = <R extends GridValidRowModel = any>({ value: valueProp }: ExternalLinkCellProps<R>) => {
  const values: ExternalLinkCellProps<R>['value'] = useMemo(() => {
    if (valueProp) {
      return Array.isArray(valueProp) ? valueProp : [valueProp];
    }
    return null;
  }, [valueProp]);

  if (values) {
    const result = values
      .map((value, index) => {
        if (value) {
          return (
            <Fragment key={index}>
              {index > 0 ? `,${NBSP}` : null}
              <Link color="inherit" href={value} target="_blank" onClick={eventStopPropagation}>
                {value}
              </Link>
            </Fragment>
          );
        }
        return null;
      })
      .filter(Boolean);

    return result.length ? <>{result}</> : null;
  }
  return <>{NULLISH_CELL_VALUE}</>;
};
